/* firmanumre-soeg.js
   Soegekortet. Ren vanilla, ingen biblioteker.

   Hele kataloget (ca. 405 numre) hentes ÉN gang som JSON fra
   /collections/alle-guldnumre?view=fn-indeks og caches i localStorage.
   Derefter sker al soegning i browseren: ingen forespoergsel pr. tastetryk,
   og cifrene kan fremhaeves position for position.

   Matchning og rangering (parse, direkteMatch, afstand, segmenter, soeg) er
   den reference-implementation designpanelet skrev og maalte: 0,03-0,36 ms
   pr. soegning paa 405 numre. Wildcards er fjernet, og et niende ciffer
   afvises med en rystelse i feltet.

   Skallen genbruger preview-arkets klasser (.fn-kig) og dets hjaelpere fra
   firmanumre-kort.js via window.fnKort: sidelaas, traek-ned-lukker, kig og
   bogmaerker. Kortet aabner ogsaa paa Cmd+F/Ctrl+F, som foer.

   Byggespecifikationen med 47 testtilfaelde ligger i CLAUDE.md-afsnittet om
   soegningen. */
(function () {
  'use strict';

  var INDEKS_URL = '/collections/alle-guldnumre?view=fn-indeks&fn_pris=1&page=';
  var CACHE = 'fn_indeks_v1';
  var CACHE_FRISK = 30 * 60 * 1000;
  var INDEKS_TIMEOUT = 12000;
  var Q_NOEGLE = 'fn_soeg_q';
  var FILTRE_NOEGLE = 'fn_soeg_filtre';
  var SIDST_SET = 'fn_sidst_set';
  var OENSKE = 'fn_oenskeliste';
  var MAKS_RAEKKER = 30;
  var TYPE_NAVNE = ['5 ens i træk', '4 ens i træk', '3 x ab', 'aaa bbb', 'aaa + 100-tabel',
    '4 x 10-tabel', '0000', '2 x 100-tabel', '1000-tabel', '2 x abc', 'aa bb cc dd',
    '2 x abcd', 'abc + abx', 'aa bb cc', '3 x 10-tabel', '2 x ab', 'aa bb', 'Systematiske'];
  var systematiskeNumre = Object.create(null);
  function kategoriNavn(q) {
    for (var i = 0; i < TYPE_NAVNE.length; i++) if (normTekst(TYPE_NAVNE[i]) === q) return TYPE_NAVNE[i];
    return null;
  }
  function nummertyper(n) {
    return TYPE_NAVNE.filter(function (navn) { return typePositioner(n, navn).length > 0; });
  }

  /* ======================================================================
     1. Matchning og rangering
     ====================================================================== */

  function normTekst(s) {
    return String(s || '').toLowerCase().replace(/[\s\-_.+]+/g, '').replace(/×/g, 'x');
  }

  function byg(indeks) {
    for (var k = 0; k < indeks.length; k++) {
      var e = indeks[k], pos = [];
      for (var i = 0; i < e.v.length; i++) {
        var c = e.v.charCodeAt(i);
        if (c >= 48 && c <= 57) pos.push(i);
      }
      e.pos = pos;
      e.typer = nummertyper(e.n);
      e.mnavn = e.typer.indexOf(e.m) !== -1 ? e.m : (e.typer[0] || '');
      e.mn = normTekst(e.mnavn);
    }
    return indeks;
  }

  var TYPE_ORD = {
    mobil: 'mobil', mobilnummer: 'mobil', mobilnumre: 'mobil', mobile: 'mobil',
    fastnet: 'fastnet', fastnetnummer: 'fastnet', fastnetnumre: 'fastnet',
    '70nummer': '70', '70numre': '70', '70nr': '70'
  };
  var LEDIG_ORD = { ledig: true, ledige: true, tilsalg: true, solgt: false, solgte: false };

  function parse(raa) {
    var s = String(raa || '').toLowerCase().trim();
    var f = { type: null, ledig: null, min: null, max: null, tagQ: '' };
    s = s.replace(/(under|max|maks|højst|hoejst|op til)\s*(\d[\d.]*)\s*(kr\.?|kroner)?/g, function (_, __, n) { f.max = +n.replace(/\./g, ''); return ' '; });
    s = s.replace(/(over|mindst|fra)\s*(\d[\d.]*)\s*(kr\.?|kroner)?/g, function (_, __, n) { f.min = +n.replace(/\./g, ''); return ' '; });

    var cif = s.replace(/\D/g, '');
    if (/^\+45|^0045/.test(s.replace(/\s/g, ''))) cif = cif.replace(/^(00)?45/, '');
    else if (cif.length === 10 && cif.indexOf('45') === 0) cif = cif.slice(2);
    var afvist = cif.length > 8;
    cif = cif.slice(0, 8);

    var ord = s.replace(/[^a-zæøå\d\s-]/g, ' ').split(/\s+/).filter(Boolean);
    var rest = [];
    for (var i = 0; i < ord.length; i++) {
      var k = ord[i].replace(/-/g, '');
      if (TYPE_ORD[k]) { f.type = TYPE_ORD[k]; continue; }
      if (k in LEDIG_ORD) { f.ledig = LEDIG_ORD[k]; continue; }
      if (/^\d+$/.test(k)) continue;
      rest.push(k);
    }
    f.tagQ = normTekst(rest.join(''));
    var erMoenster = f.tagQ.length > 0 && /[a-zæøå]/.test(f.tagQ.replace(/x/g, ''));
    if (erMoenster) { f.tagQ = normTekst(ord.join('')); cif = ''; }

    /* Formsoegning: bogstaver er variable (samme bogstav = samme ciffer,
       forskellige bogstaver = forskellige cifre), `*` `?` `_` `.` er et
       vilkaarligt ciffer, og tal er faste. "ab ab" finder 20 34 20 34-formen
       hvor som helst i nummeret, "*0 *0" finder ...10 20..., "aa bb" to par.
       Forkortelser for butikkens egne former ("2 x ab", "ab", "abc") gaar
       stadig til tagsene - det afgoeres i soeg(), hvor tagsene kendes. */
    var moen = null;
    var raaForm = s.replace(/\b(mobil|mobilnummer|mobilnumre|mobile|fastnet|fastnetnummer|fastnetnumre|ledig|ledige|solgt|solgte|til salg)\b/g, ' ').replace(/[\s\-]/g, '');
    if (/^[0-9a-z*?_.]{2,8}$/.test(raaForm) && /[a-z*?_.]/.test(raaForm) && !/^\d+x[a-z]+$/.test(raaForm)) {
      var bogst = raaForm.replace(/[^a-z]/g, ''), unik = {}, gentag = false;
      for (var b = 0; b < bogst.length; b++) { if (unik[bogst.charAt(b)]) gentag = true; unik[bogst.charAt(b)] = 1; }
      var kunBogst = /^[a-z]+$/.test(raaForm);
      /* "ab" og "abc" alene er for brede som form (de passer paa alt) og
         betyder i butikken en NAVNGIVET form - de bliver tag-opslag. */
      if (!(kunBogst && !gentag && raaForm.length < 4)) moen = raaForm;
    }
    if (moen) { cif = ''; afvist = false; }
    return { cif: cif, f: f, afvist: afvist, moen: moen, moenVist: moen ? s.replace(/\s+/g, ' ').trim() : '' };
  }

  /* Bygger en matcher for en form. test(n, start) svarer true, hvis formen
     passer paa cifrene fra `start`. */
  function bygForm(moen) {
    var tegn = [], grupper = {}, antal = 0, i;
    for (i = 0; i < moen.length; i++) {
      var c = moen.charAt(i);
      if (/[0-9]/.test(c)) tegn.push({ t: 'tal', v: c });
      else if (/[a-z]/.test(c)) { if (!(c in grupper)) grupper[c] = antal++; tegn.push({ t: 'var', g: grupper[c] }); }
      else tegn.push({ t: 'alt' });
    }
    var L = tegn.length;
    return {
      laengde: L,
      antalVar: antal,
      test: function (n, start) {
        if (start + L > n.length) return false;
        var bind = [], brugt = {}, k;
        for (k = 0; k < L; k++) {
          var d = n.charAt(start + k), tk = tegn[k];
          if (tk.t === 'tal') { if (d !== tk.v) return false; }
          else if (tk.t === 'var') {
            if (bind[tk.g] === undefined) { if (brugt[d]) return false; bind[tk.g] = d; brugt[d] = 1; }
            else if (bind[tk.g] !== d) return false;
          }
        }
        return true;
      }
    };
  }

  var KL = { PRAECIS: 0, PRAEFIKS: 1, DELSTRENG: 2, MOENSTER: 3, NAER: 4 };

  function direkteMatch(e, q) {
    var L = q.length;
    for (var s = 0; s + L <= 8; s++) {
      if (e.n.substr(s, L) === q) {
        if (s === 0) return { kl: L === 8 ? KL.PRAECIS : KL.PRAEFIKS, sub: 0, fra: 0, til: L };
        var grp = e.pos[s] > 0 && e.v.charAt(e.pos[s] - 1) === ' ' ? 0 : 1;
        return { kl: KL.DELSTRENG, sub: s * 2 + grp, fra: s, til: s + L };
      }
    }
    return null;
  }

  /* Vaegtet Damerau-OSA med fri start og fri slut i nummeret. De foerst
     tastede cifre er nummerets identitet og koster mest at tage fejl af. */
  var W = [1.5, 1.5, 1.25, 1.25, 1, 1, 1, 1];
  var D = new Float64Array(81);
  function afstand(q, n, spor) {
    var L = q.length, i, j;
    for (i = 0; i <= 8; i++) D[i] = Math.min(1.2, 0.3 * i);
    for (j = 1; j <= L; j++) {
      D[j * 9] = D[(j - 1) * 9] + W[j - 1];
      var qc = q.charCodeAt(j - 1);
      for (i = 1; i <= 8; i++) {
        var nc = n.charCodeAt(i - 1);
        var best = D[(j - 1) * 9 + (i - 1)] + (qc === nc ? 0 : W[j - 1]);
        var del = D[(j - 1) * 9 + i] + W[j - 1]; if (del < best) best = del;
        var ins = D[j * 9 + (i - 1)] + 1; if (ins < best) best = ins;
        if (j > 1 && i > 1 && q.charCodeAt(j - 2) === nc && qc === n.charCodeAt(i - 2)) {
          var tr = D[(j - 2) * 9 + (i - 2)] + W[j - 2]; if (tr < best) best = tr;
        }
        D[j * 9 + i] = best;
      }
    }
    var bedst = Infinity, slut = 8;
    for (i = 0; i <= 8; i++) if (D[L * 9 + i] < bedst) { bedst = D[L * 9 + i]; slut = i; }
    if (!spor) return { d: bedst };
    var ramt = []; j = L; i = slut;
    while (j > 0 && i > 0) {
      var her = D[j * 9 + i], qc2 = q.charCodeAt(j - 1), nc2 = n.charCodeAt(i - 1);
      if (j > 1 && i > 1 && q.charCodeAt(j - 2) === nc2 && qc2 === n.charCodeAt(i - 2) &&
          Math.abs(her - (D[(j - 2) * 9 + (i - 2)] + W[j - 2])) < 1e-9) { j -= 2; i -= 2; continue; }
      if (Math.abs(her - (D[(j - 1) * 9 + (i - 1)] + (qc2 === nc2 ? 0 : W[j - 1]))) < 1e-9) {
        if (qc2 === nc2) ramt.push(i - 1); j--; i--; continue;
      }
      if (Math.abs(her - (D[(j - 1) * 9 + i] + W[j - 1])) < 1e-9) { j--; continue; }
      i--;
    }
    return { d: bedst, ramt: ramt.reverse() };
  }
  function MAX_D(L) { return L <= 4 ? 2.5 : L <= 6 ? 3.0 : 4.5; }

  function segmenter(e, ramt) {
    var seg = [], k = 0, r = 0, v = e.v, pos = e.pos;
    for (var i = 0; i < v.length; i++) {
      var hit = false;
      if (pos[k] === i) { hit = ramt[r] === k; if (hit) r++; k++; }
      else hit = seg.length > 0 && seg[seg.length - 1].hit && ramt[r] === k;
      var last = seg[seg.length - 1];
      if (last && last.hit === hit) last.t += v.charAt(i); else seg.push({ t: v.charAt(i), hit: hit });
    }
    return seg;
  }
  function interval(fra, til) { var a = []; for (var k = fra; k < til; k++) a.push(k); return a; }
  function sortNoegle(a, b) { return a.kl - b.kl || (b.e.a - a.e.a) || a.sub - b.sub || b.e.p - a.e.p || (a.e.n < b.e.n ? -1 : 1); }
  function sortNaer(a, b) { return Math.round(a.sub * 2) - Math.round(b.sub * 2) || (b.e.a - a.e.a) || a.sub - b.sub || b.e.p - a.e.p || (a.e.n < b.e.n ? -1 : 1); }

  function soeg(indeks, raa, ui, kunTraef) {
    var p = parse(raa), cif = p.cif, f = p.f;
    var type = f.type || ui.type || null;
    var ledig = f.ledig != null ? f.ledig : (ui.ledig != null ? ui.ledig : null);
    var min = f.min != null ? f.min : null;
    var max = f.max != null ? f.max : (ui.max || null);
    var gemte = ui.gemte ? gemteHandles() : null;
    var moenster = ui.moenster || kategoriNavn(f.tagQ) || null;

    var kand = [], i, e;
    for (i = 0; i < indeks.length; i++) {
      e = indeks[i];
      if (type && e.t !== type) continue;
      if (ledig != null && e.a !== ledig) continue;
      if (min != null && e.p < min) continue;
      if (max != null && e.p > max) continue;
      if (gemte && !gemte[e.h]) continue;
      if (moenster && e.typer.indexOf(moenster) === -1) continue;
      kand.push(e);
    }

    /* Et navngivet tag slaar formen: "aa bb cc dd" er baade en gyldig form
       og et tag, og tagget er butikkens egen, snaevrere afgraensning. */
    var tagFindes = !!kategoriNavn(f.tagQ);
    if (f.tagQ) for (i = 0; i < indeks.length; i++) if (indeks[i].mn === f.tagQ) { tagFindes = true; break; }
    var form = p.moen && !tagFindes ? bygForm(p.moen) : null;

    var hits = [];
    if (form) {
      var L0 = form.laengde;
      for (i = 0; i < kand.length; i++) {
        e = kand[i];
        for (var st = 0; st + L0 <= 8; st++) {
          if (!form.test(e.n, st)) continue;
          var grp0 = st === 0 ? 0 : (e.pos[st] > 0 && e.v.charAt(e.pos[st] - 1) === ' ' ? 0 : 1);
          hits.push({ e: e, kl: st === 0 ? (L0 === 8 ? KL.PRAECIS : KL.PRAEFIKS) : KL.DELSTRENG, sub: st * 2 + grp0, ramt: interval(st, st + L0) });
          break;
        }
      }
    } else if (cif) {
      for (i = 0; i < kand.length; i++) { var m = direkteMatch(kand[i], cif); if (m) hits.push({ e: kand[i], kl: m.kl, sub: m.sub, ramt: interval(m.fra, m.til) }); }
    } else if (f.tagQ) {
      for (i = 0; i < kand.length; i++) {
        e = kand[i];
        if (moenster) { hits.push({ e: e, kl: KL.MOENSTER, sub: 0, ramt: typePositioner(e.n, moenster) }); continue; }
        var navne = e.typer.map(normTekst), bedste = 3;
        if (e.m) navne.push(normTekst(e.m));
        for (var nt = 0; nt < navne.length; nt++) {
          if (navne[nt] === f.tagQ) bedste = 0;
          else if (navne[nt].indexOf(f.tagQ) === 0) bedste = Math.min(bedste, 1);
          else if (navne[nt].indexOf(f.tagQ) !== -1) bedste = Math.min(bedste, 2);
        }
        if (bedste < 3) hits.push({ e: e, kl: KL.MOENSTER, sub: bedste, ramt: [] });
      }
    } else {
      for (i = 0; i < kand.length; i++) hits.push({ e: kand[i], kl: KL.MOENSTER, sub: 0, ramt: [] });
    }
    hits.sort(sortNoegle);

    var naer = [], ledigeFund = false, overskriftNaer = 'Tættest på';
    for (i = 0; i < hits.length; i++) if (hits[i].e.a) { ledigeFund = true; break; }
    if (!kunTraef && cif && cif.length >= 3 && hits.length < 3) {
      var set = {}; for (i = 0; i < hits.length; i++) set[hits[i].e.h] = 1;
      var L = cif.length;
      if (hits.length > 0 && !ledigeFund) {
        var m0 = hits[0].e.mnavn, p0 = hits[0].e.p, alt = [];
        for (i = 0; i < kand.length; i++) { e = kand[i]; if (e.a && e.mnavn === m0 && !set[e.h]) alt.push(e); }
        alt.sort(function (x, y) { return Math.abs(Math.log(x.p / p0)) - Math.abs(Math.log(y.p / p0)); });
        for (i = 0; i < Math.min(3, alt.length); i++) { naer.push({ e: alt[i], kl: KL.NAER, sub: 0, ramt: [], samme: true }); set[alt[i].h] = 1; }
      }
      var alle = [];
      for (i = 0; i < kand.length; i++) { e = kand[i]; if (set[e.h]) continue; alle.push({ e: e, kl: KL.NAER, sub: afstand(cif, e.n).d, ramt: null }); }
      alle.sort(sortNaer);
      var graense = ledigeFund ? 1.25 : MAX_D(L);
      var fyld = [];
      for (i = 0; i < alle.length && fyld.length < 5 - naer.length; i++) if (alle[i].sub <= graense) fyld.push(alle[i]);
      if (fyld.length === 0 && naer.length === 0 && !ledigeFund && L >= 6) { fyld = alle.slice(0, 3); overskriftNaer = 'Det nærmeste vi har'; }
      for (i = 0; i < fyld.length; i++) { fyld[i].ramt = afstand(cif, fyld[i].e.n, true).ramt; naer.push(fyld[i]); }
    }
    return { cif: cif, afvist: p.afvist, tagQ: f.tagQ, form: form ? p.moen : null, formVist: form ? p.moenVist : '',
             filtre: { type: type, ledig: ledig, max: max, moenster: moenster, gemte: !!gemte },
             hits: hits, naer: naer, ledigeFund: ledigeFund, overskriftNaer: overskriftNaer, kand: kand };
  }

  /* ======================================================================
     2. Lager: indeks, sidst set, gemte
     ====================================================================== */

  function laesJSON(noegle, lager) {
    try { var v = (lager || window.localStorage).getItem(noegle); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function skrivJSON(noegle, vaerdi, lager) {
    try { (lager || window.localStorage).setItem(noegle, JSON.stringify(vaerdi)); } catch (e) {}
  }
  function gemteHandles() {
    var l = laesJSON(OENSKE) || [], ud = {};
    for (var i = 0; i < l.length; i++) if (l[i] && l[i].handle) ud[l[i].handle] = 1;
    return ud;
  }
  function sidstSet() { var l = laesJSON(SIDST_SET); return Array.isArray(l) ? l : []; }
  function noterSet(handle) {
    if (!handle) return;
    var l = sidstSet().filter(function (h) { return h !== handle; });
    l.unshift(handle);
    skrivJSON(SIDST_SET, l.slice(0, 8));
  }

  var indeks = null, indeksLoefte = null, indeksFejl = false, hentetVed = 0;

  function gyldigtIndeks(numre) {
    if (!Array.isArray(numre)) return false;
    for (var i = 0; i < numre.length; i++) {
      var e = numre[i];
      if (!e || typeof e.h !== 'string' || !e.h || typeof e.n !== 'string' || !/^\d{8}$/.test(e.n) ||
          typeof e.v !== 'string' || typeof e.m !== 'string' || typeof e.t !== 'string' ||
          typeof e.p !== 'number' || !isFinite(e.p) || e.p < 0 ||
          (e.c !== null && (typeof e.c !== 'number' || !isFinite(e.c) || e.c < 0)) || typeof e.a !== 'boolean') return false;
    }
    return true;
  }

  function hentSide(side) {
    var controller = window.AbortController ? new window.AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, afvis) {
      timer = window.setTimeout(function () {
        if (controller) controller.abort();
        afvis(new Error('Søgeindekset svarede ikke i tide'));
      }, INDEKS_TIMEOUT);
    });
    var valg = { credentials: 'same-origin' };
    if (controller) valg.signal = controller.signal;
    var net = fetch(INDEKS_URL + side, valg).then(function (r) {
      if (!r.ok) throw new Error('Kunne ikke hente søgeindekset');
      return r.json();
    }).then(function (d) {
      if (!d || d.side !== side || !Number.isInteger(d.sider) || d.sider < 0 || d.sider > 50 ||
          !Number.isInteger(d.antal) || d.antal < 0 || !gyldigtIndeks(d.numre)) throw new Error('Ugyldigt søgeindeks');
      return d;
    });
    return Promise.race([net, timeout]).then(function (d) { window.clearTimeout(timer); return d; }, function (e) { window.clearTimeout(timer); throw e; });
  }

  function hentSider() {
    return hentSide(1).then(function (d) {
      var sider = d.sider || 1, alle = d.numre, loefter = [];
      for (var s = 2; s <= sider; s++) loefter.push(hentSide(s));
      return Promise.all(loefter).then(function (rest) {
        for (var i = 0; i < rest.length; i++) {
          if (rest[i].antal !== d.antal || rest[i].sider !== d.sider) throw new Error('Søgeindekset ændrede sig under indlæsning');
          alle = alle.concat(rest[i].numre);
        }
        if (alle.length !== d.antal) throw new Error('Søgeindekset er ufuldstændigt');
        return { antal: d.antal, numre: alle };
      });
    });
  }

  /* Cache: yngre end 30 min bruges direkte og opdateres i baggrunden.
     Aeldre bruges til foerste tegning, mens den nye hentes. */
  function hentIndeks(tving) {
    if (indeksLoefte) return indeksLoefte;
    if (!tving && indeks && !indeksFejl && Date.now() - hentetVed < CACHE_FRISK) return Promise.resolve(indeks);
    var c = laesJSON(CACHE);
    var gyldigCache = c && gyldigtIndeks(c.numre) && typeof c.ts === 'number' && isFinite(c.ts);
    var frisk = gyldigCache && Date.now() - c.ts >= 0 && Date.now() - c.ts < CACHE_FRISK;
    if (gyldigCache && !indeks) { indeks = byg(c.numre); hentetVed = c.ts; }
    indeksFejl = false;
    var net = hentSider().then(function (d) {
      var nyt = byg(d.numre);
      var aendret = !indeks || indeks.length !== nyt.length;
      if (!aendret) for (var i = 0; i < nyt.length; i++) { if (nyt[i].a !== indeks[i].a || nyt[i].p !== indeks[i].p || nyt[i].c !== indeks[i].c || nyt[i].h !== indeks[i].h || nyt[i].n !== indeks[i].n || nyt[i].v !== indeks[i].v || nyt[i].t !== indeks[i].t || nyt[i].m !== indeks[i].m) { aendret = true; break; } }
      skrivJSON(CACHE, { ts: Date.now(), antal: d.antal, numre: d.numre });
      hentetVed = Date.now();
      if (aendret) { indeks = nyt; if (aaben) tegn(); }
      return indeks;
    })['catch'](function () {
      indeksFejl = true;
      if (aaben) tegn();
      return indeks;
    });
    /* Et fejlet loefte maa ikke gemmes for resten af besoegget. */
    indeksLoefte = net.then(function (resultat) { indeksLoefte = null; return resultat; });
    return frisk && !tving ? Promise.resolve(indeks) : indeksLoefte;
  }

  function forhent() {
    if (indeksLoefte) return;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    hentIndeks();
  }

  /* ======================================================================
     3. Kortet
     ====================================================================== */

  var rod, kort, indhold, resultatEl, listeTitel, felt, ryd, chipsEl, statusEl, bundEl, sekundaer, tomEl, listeEl, mereEl, kontaktEl, hEl, linjeEl, naerHEl, naerListe;
  var startNumre = [], startHTML = '', sidsteHTML = null;
  var traekBundet = false, traekTimer = null, traekNr = 0;
  var annullerTraek = function () {};
  function nulstilTraek() {
    traekNr++;
    if (traekTimer) window.clearTimeout(traekTimer);
    traekTimer = null;
    annullerTraek();
    rod.classList.remove('fn-soeg--traek', 'fn-soeg--retur', 'fn-soeg--lukker');
    kort.style.removeProperty('transform');
  }
  function bindSoegTraek() {
    var greb = rod, rulEl = null, rulVenter = false, klikBlokeretTil = 0;
    rod.addEventListener('click', function (e) { if (Date.now() < klikBlokeretTil) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    var aktiv = false, laast = false, x0 = 0, y0 = 0, d = 0, ySidst = 0, tidSidst = 0, fart = 0, hoejde = 0;
    annullerTraek = function () { aktiv = laast = false; };
    function afslut(lukke) {
      aktiv = laast = false; klikBlokeretTil = Date.now() + 450;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { if (lukke) luk(false); else nulstilTraek(); return; }
      rod.classList.remove('fn-soeg--traek');
      rod.classList.add(lukke ? 'fn-soeg--lukker' : 'fn-soeg--retur');
      var nr = ++traekNr;
      window.requestAnimationFrame(function () {
        if (nr !== traekNr || !aaben) return;
        kort.style.transform = 'translate3d(0,' + (lukke ? hoejde + 48 : 0) + 'px,0)';
        traekTimer = window.setTimeout(function () {
          if (nr !== traekNr || !aaben) return;
          if (lukke) luk(false); else nulstilTraek();
        }, 240);
      });
    }
    greb.addEventListener('touchstart', function (e) {
      if (!telefon() || !aaben || e.touches.length !== 1) return;
      nulstilTraek(); aktiv = true; d = fart = 0;
      rulEl = e.target.closest ? e.target.closest('.fn-kig__indhold') : null;
      rulVenter = !!(rulEl && rulEl.scrollTop > 1);
      x0 = e.touches[0].clientX; y0 = ySidst = e.touches[0].clientY;
      tidSidst = Date.now(); hoejde = kort.getBoundingClientRect().height;
    }, { passive: true });
    greb.addEventListener('touchmove', function (e) {
      if (!aktiv) return;
      if (e.touches.length !== 1) { afslut(false); return; }
      var t = e.touches[0], dy = t.clientY - y0, dx = t.clientX - x0;
      if (!laast) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
        if (dy <= 0 || Math.abs(dx) > Math.abs(dy)) { aktiv = false; return; }
        if (rulEl && rulEl.scrollTop > 1) return;
        if (rulVenter) { rulVenter = false; y0 = ySidst = t.clientY; tidSidst = Date.now(); return; }
        laast = true; klikBlokeretTil = Date.now() + 600; trykRaekke = null; rod.classList.add('fn-soeg--traek');
      }
      if (e.cancelable) e.preventDefault();
      var nu = Date.now(); fart = (t.clientY - ySidst) / Math.max(nu - tidSidst, 1);
      ySidst = t.clientY; tidSidst = nu; d = Math.max(0, dy);
      kort.style.transform = 'translate3d(0,' + d + 'px,0)';
    }, { passive: false });
    greb.addEventListener('touchend', function () {
      if (!aktiv) return;
      if (!laast) { aktiv = false; return; }
      var hurtig = Date.now() - tidSidst < 100 && d > 40 && fart > 0.45;
      afslut(d > Math.min(140, Math.max(80, hoejde * 0.18)) || hurtig);
    }, { passive: true });
    greb.addEventListener('touchcancel', function () { if (aktiv) afslut(false); }, { passive: true });
  }
  var aaben = false, aabnedeFra = null, sidstFokus = null, viste = MAKS_RAEKKER, seneste = null, tegnPlanlagt = false;
  var ui = { ledig: null, type: null, max: null, gemte: false, moenster: null };
  var statusTimer = null, langsomTimer = null, langsom = false, aabnetKl = 0, beholdRul = false;
  var venterPaaHistorik = false, lukkeNr = 0;
  var trykRaekke = null, ignorerKlikIndtil = 0;
  /* Efter luk gives fokus tilbage til det, der aabnede kortet. Er det et af
     de skrivebeskyttede felter, maa dets focus-lytter IKKE aabne igen -
     maalt: Escape og luk-knappen aabnede kortet forfra. */
  var ignorerFokusIndtil = 0;
  /* firmanumre-kort.js definerer window.fnKort, men begge scripts er `defer`,
     og raekkefoelgen i dokumentet er ikke garanteret. Slaas op ved hvert
     kald, aldrig én gang ved start - foerste udgave fangede `undefined`,
     og et klik paa en raekke navigerede til produktsiden i stedet for at
     aabne preview-kortet. */
  function fk() { return window.fnKort || null; }

  /* Sidelaasen er soegekortets EGEN kopi af den faelles taeller-laas (se
     firmanumre-kurv.js). Den maa ikke laanes fra firmanumre-kort.js: den
     har ét `erLaast`-flag pr. fil, saa naar preview-kortet aabnede oven paa
     soegekortet, saa dets laasSiden "allerede laast" og talte ikke op - og
     dets laasOp slap derefter hele siden, mens soegekortet stod aabent.
     Maalt: data-fn-laast gik 1 -> null i stedet for 1 -> 2 -> 1. */
  var laastY = 0, erLaast = false;
  function laasSiden() {
    if (erLaast) return;
    erLaast = true;
    var h = document.documentElement;
    var n = parseInt(h.getAttribute('data-fn-laast') || '0', 10);
    h.setAttribute('data-fn-laast', String(n + 1));
    if (n > 0) return;
    laastY = window.pageYOffset || h.scrollTop || 0;
    h.setAttribute('data-fn-laast-y', String(laastY));
    var b = document.body, bjaelke = window.innerWidth - h.clientWidth;
    h.style.overflow = 'hidden'; b.style.overflow = 'hidden';
    if (bjaelke > 0) b.style.paddingRight = bjaelke + 'px';
    if (telefon()) { b.style.position = 'fixed'; b.style.top = (-laastY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%'; }
  }
  function laasOp() {
    if (!erLaast) return;
    erLaast = false;
    var h = document.documentElement;
    var n = parseInt(h.getAttribute('data-fn-laast') || '1', 10) - 1;
    if (n > 0) { h.setAttribute('data-fn-laast', String(n)); return; }
    var y = parseInt(h.getAttribute('data-fn-laast-y') || '0', 10);
    h.removeAttribute('data-fn-laast'); h.removeAttribute('data-fn-laast-y');
    var b = document.body;
    h.style.overflow = ''; b.style.overflow = ''; b.style.paddingRight = '';
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    window.scrollTo(0, y);
  }

  function esc(t) { return fk() && fk().esc ? fk().esc(t) : String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function telefon() { return window.matchMedia('(max-width: 768px)').matches; }
  function formatQ(cif) { return cif.replace(/(\d\d)(?=\d)/g, '$1 '); }
  function formatBeloeb(p) {
    var dele = p.toFixed(2).split('.');
    return dele[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (dele[1] === '00' ? '' : ',' + dele[1]);
  }
  function formatPris(p) { return 'kr. ' + formatBeloeb(p); }
  function harTilbud(e) { return e.c !== null && e.c > e.p; }
  function prisHTML(e) {
    return '<span class="fn-soeg__aktuelpris' + (harTilbud(e) ? ' fn-soeg__aktuelpris--tilbud' : '') + '">' + esc(formatPris(e.p)) + '</span>' +
      (harTilbud(e) ? '<s class="fn-soeg__foerpris">' + esc(formatBeloeb(e.c)) + '</s>' : '');
  }
  function prisOplaest(e) {
    return (harTilbud(e) ? 'tilbudspris ' : '') + formatBeloeb(e.p) + ' kroner' +
      (harTilbud(e) ? ', førpris ' + formatBeloeb(e.c) + ' kroner' : '');
  }
  function typeNavn(t) { return t === 'fastnet' ? 'Fastnet' : t === '70' ? '70-nummer' : 'Mobil'; }
  function typeOplaest(t) { return t === 'fastnet' ? 'fastnet' : t === '70' ? '70-nummer' : 'mobil'; }
  function find(handle) { if (!indeks) return null; for (var i = 0; i < indeks.length; i++) if (indeks[i].h === handle) return indeks[i]; return null; }

  function bogmaerkeSvg(str) {
    return '<svg viewBox="0 0 24 24" width="' + (str || 19) + '" height="' + (str || 19) + '" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3.8h12a1 1 0 0 1 1 1v15.6l-7-4.3-7 4.3V4.8a1 1 0 0 1 1-1z"/></svg>';
  }

  function billedeHTML(e, cifre, klasse) {
    return '<span class="fn-soeg__billedramme' + (klasse ? ' ' + klasse : '') + '" aria-hidden="true">' +
      '<span class="fn-nrkort"><span class="fn-nrkort__tal">' + cifre + '</span></span>' +
      (e.a ? '' : '<span class="fn-sold-ribbon">SOLGT</span>') + '</span>';
  }

  function visteKategorier(e) {
    var valgt = ui.moenster || (seneste && kategoriNavn(seneste.tagQ)), navne = [];
    if (valgt && e.typer.indexOf(valgt) !== -1) navne.push(valgt);
    if (e.mnavn && navne.indexOf(e.mnavn) === -1) navne.push(e.mnavn);
    for (var i = 0; i < e.typer.length && navne.length < 3; i++) {
      var navn = e.typer[i];
      if (navne.indexOf(navn) !== -1) continue;
      if (navn === '4 ens i træk' && e.typer.indexOf('5 ens i træk') !== -1) continue;
      if (navn === '3 x 10-tabel' && e.typer.indexOf('4 x 10-tabel') !== -1) continue;
      if (navn === '2 x ab' && e.typer.indexOf('3 x ab') !== -1) continue;
      if (navn === 'aa bb' && (e.typer.indexOf('aa bb cc') !== -1 || e.typer.indexOf('aa bb cc dd') !== -1)) continue;
      if (navn === 'aa bb cc' && e.typer.indexOf('aa bb cc dd') !== -1) continue;
      navne.push(navn);
    }
    return navne.slice(0, 3);
  }
  function matchPositioner(h) {
    var valgt = ui.moenster || (seneste && kategoriNavn(seneste.tagQ));
    if (valgt && h.e.typer.indexOf(valgt) !== -1) return typePositioner(h.e.n, valgt);
    if (h.ramt && h.ramt.length) return h.ramt;
    return h.e.mnavn ? typePositioner(h.e.n, h.e.mnavn) : [];
  }
  function raekke(h, opts) {
    var e = h.e, seg = segmenter(e, matchPositioner(h)), cifre = '';
    for (var i = 0; i < seg.length; i++) cifre += seg[i].hit ? '<span class="hit">' + esc(seg[i].t) + '</span>' : esc(seg[i].t);
    var pris = formatPris(e.p);
    var gemt = !!gemteHandles()[e.h];
    var label = e.v + ', ' + typeOplaest(e.t) + ', ' + prisOplaest(e) + (e.a ? ', kan købes' : ', solgt');
    var kategorier = visteKategorier(e), meta = '';
    for (var kt = 0; kt < kategorier.length; kt++) meta += '<button type="button" class="fn-soeg__moenster" data-m="' + esc(kategorier[kt]) + '" aria-label="Vis nummertypen ' + esc(kategorier[kt]) + '">' + esc(kategorier[kt]) + '</button>';
    return '<li class="fn-soeg__res' + (e.a ? '' : ' fn-soeg__res--solgt') + (gemt ? ' fn-soeg__res--gemt' : '') + '" data-h="' + esc(e.h) + '" data-i="' + esc(e.v) + '">' +
      /* Nummerkortet er CSS-skabelonen fra firmanumre-brand.css (.fn-nrkort):
         samme groenne skaerm som produktbilledet, uden en eneste
         billedforespoergsel. Traefne cifre understreges ogsaa inde i kortet. */
      billedeHTML(e, cifre, 'fn-soeg__kort') +
      '<a class="fn-soeg__nr" href="/products/' + esc(e.h) + '" tabindex="-1" aria-label="' + esc(label) + '">' +
      '<span class="fn-soeg__cifre" aria-hidden="true">' + cifre + '</span>' +
      '</a>' +
      '<span class="fn-soeg__pris" aria-hidden="true">' + prisHTML(e) + '</span>' +
      '<span class="fn-soeg__undertekst"><span class="fn-soeg__meta">' + esc(typeNavn(e.t)) + '</span><span class="fn-soeg__kategorier">' + meta + '</span></span>' +
      (e.a ? '<button type="button" class="fn-soeg__gem" data-fn-hjerte data-handle="' + esc(e.h) + '" data-titel="' + esc(e.v) + '" data-type="' + esc(e.t === 'fastnet' ? 'fastnet' : 'mobil') + '" data-pris="' + esc(pris) + '" data-billede="' + esc(e.i || '') + '" data-url="/products/' + esc(e.h) + '" aria-pressed="' + (gemt ? 'true' : 'false') + '" aria-label="' + (gemt ? 'Fjern ' : 'Gem ') + esc(e.v) + (gemt ? ' fra' : ' på') + ' ønskelisten">' + bogmaerkeSvg(19) + '</button>' : '') +
      '</li>';
  }
  /* Safari kan undlade click, naar pointerdown bevarer tastaturfokus.
     Vaelg knappen paa et kort tryk, og lad traek/annullerede tryk vaere. */
  function bindTrykKnapper(el, selector) {
    var tryk = null, senesteTryk = 0, senesteX = 0, senesteY = 0;
    el.addEventListener('click', function (e) {
      /* Gentegning kan flytte en raekke under fingeren. Forbrug det
         browserklik der ellers ville vaelge nummeret nedenunder. */
      if (e.isTrusted && e.detail > 0 && Date.now() - senesteTryk < 500 && Math.abs(e.clientX - senesteX) < 12 && Math.abs(e.clientY - senesteY) < 12) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    el.addEventListener('pointerdown', function (e) {
      tryk = null;
      if (e.pointerType === 'mouse') senesteTryk = 0;
      if ((e.pointerType !== 'touch' && e.pointerType !== 'pen') || !e.isPrimary || !e.target.closest) return;
      var b = e.target.closest(selector);
      if (!b || b.disabled) return;
      tryk = { id: e.pointerId, x: e.clientX, y: e.clientY, tid: Date.now(), knap: b };
      e.preventDefault();
    });
    el.addEventListener('pointermove', function (e) { if (tryk && (Math.abs(e.clientX - tryk.x) > 10 || Math.abs(e.clientY - tryk.y) > 10)) tryk = null; });
    el.addEventListener('pointercancel', function () { tryk = null; });
    el.addEventListener('pointerup', function (e) {
      var t = tryk; tryk = null;
      if (!t || e.pointerId !== t.id || Date.now() - t.tid > 600 || Math.abs(e.clientX - t.x) > 10 || Math.abs(e.clientY - t.y) > 10 || !t.knap.isConnected) return;
      senesteX = e.clientX; senesteY = e.clientY; senesteTryk = Date.now();
      t.knap.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, detail: 1, clientX: e.clientX, clientY: e.clientY }));
    });
  }
  /* Katalogeksempler bruges som illustration, mens hele indekset hentes.
     Antal beregnes altid fra det komplette indeks med samme filtre som klik. */
  var TYPE_EKSEMPLER = {
    '3 x ab': ['98989800', '98 98 98 00'], '2 x abc': ['20502502', '20 502 502'],
    'aa bb cc dd': ['66556655', '66 55 66 55'], '5 ens i træk': ['40288888', '402 88888'],
    '3 x 10-tabel': ['70700011', '70 70 00 11'], '4 ens i træk': ['70700001', '70 70 00 01'],
    'aaa bbb': ['50777555', '50 777 555'], 'aaa + 100-tabel': ['40888300', '40 888 300'],
    '4 x 10-tabel': ['70600060', '70 60 00 60'], '0000': ['41800000', '41 80 00 00'],
    '2 x 100-tabel': ['69700200', '69 700 200'], '1000-tabel': ['24907000', '24 90 7000'],
    '2 x abcd': ['20342034', '2034 2034'], 'abc + abx': ['40888488', '40 888 488'],
    'aa bb cc': ['60556677', '60 55 66 77'], '2 x ab': ['71710100', '71 71 01 00'],
    'aa bb': ['20220001', '20 22 00 01'], 'Systematiske': ['93929190', '93 92 91 90']
  };
  function typePositioner(n, navn) {
    var match, i, j, ud = [], laengde, gange, gruppe, par = [], forskelle = 0;
    if (navn === 'Systematiske') {
      if (!systematiskeNumre[n]) return [];
      var tal = [Number(n.slice(0, 2)), Number(n.slice(2, 4)), Number(n.slice(4, 6)), Number(n.slice(6, 8))];
      var trin = tal[1] - tal[0];
      if (trin && tal[2] - tal[1] === trin && tal[3] - tal[2] === trin) return interval(0, 8);
      for (i = 0; i < 2; i++) { trin = tal[i + 1] - tal[i]; if (trin && tal[i + 2] - tal[i + 1] === trin) return interval(i * 2, i * 2 + 6); }
      /* Kuraterede dobbelte trapper, fx 93 94 / 10 11. */
      return interval(0, 8);
    }
    var ens = /^(4|5) ens i træk$/.exec(navn);
    if (ens) {
      match = new RegExp('(\\d)\\1{' + (Number(ens[1]) - 1) + ',}').exec(n);
      return match ? interval(match.index, match.index + match[0].length) : [];
    }
    if (navn === '0000' || navn === '1000-tabel') {
      match = (navn === '0000' ? /0000$/ : /[1-9]000/).exec(n);
      return match ? interval(match.index + (navn === '0000' ? 0 : 1), match.index + 4) : [];
    }
    if (navn === '3 x ab' || navn === '2 x ab' || navn === '2 x abc' || navn === '2 x abcd') {
      laengde = navn === '2 x abcd' ? 4 : navn === '2 x abc' ? 3 : 2;
      gange = navn === '3 x ab' ? 3 : 2;
      for (i = 0; i + laengde * gange <= 8; i++) {
        gruppe = n.slice(i, i + laengde);
        if (n.slice(i, i + laengde * gange) === new Array(gange + 1).join(gruppe)) return interval(i, i + laengde * gange);
      }
      if (navn === '3 x ab') for (i = 0; i < 8; i += 2) {
        ud = [];
        for (j = 0; j < 8; j += 2) if (n.slice(i, i + 2) === n.slice(j, j + 2)) ud = ud.concat(interval(j, j + 2));
        if (ud.length >= 6) return ud;
      }
      return [];
    }
    if (navn === 'aaa bbb') return /^(\d)\1\1(\d)\2\2$/.test(n.slice(2)) && n[2] !== n[5] ? interval(2, 8) : [];
    if (navn === 'aaa + 100-tabel') {
      var a = n.slice(2, 5), b = n.slice(5);
      if (/^(\d)\1\1$/.test(a) && /00$/.test(b)) return interval(2, 5).concat([6, 7]);
      if (/^(\d)\1\1$/.test(b) && /00$/.test(a)) return [3, 4].concat(interval(5, 8));
      return [];
    }
    if (navn === '2 x 100-tabel') return /00$/.test(n.slice(2, 5)) && /00$/.test(n.slice(5)) ? [3, 4, 6, 7] : [];
    if (navn === 'abc + abx') {
      for (i = 0; i < 3; i++) if (n[i + 2] !== n[i + 5]) forskelle++; else ud = ud.concat([i + 2, i + 5]);
      return forskelle === 1 ? ud.sort(function (a, b) { return a - b; }) : [];
    }
    if (/^aa bb( cc( dd)?)?$/.test(navn) || /^(3|4) x 10-tabel$/.test(navn)) {
      var tiere = navn.indexOf('10-tabel') !== -1;
      var krav = tiere ? Number(navn[0]) : navn === 'aa bb cc dd' ? 4 : navn === 'aa bb cc' ? 3 : 2;
      for (i = 0; i < 8; i += 2) if (tiere ? n[i + 1] === '0' : n[i] === n[i + 1]) par.push(i);
      if (par.length < krav) return [];
      for (i = 0; i < krav; i++) ud = ud.concat(tiere ? [par[i] + 1] : interval(par[i], par[i] + 2));
      return ud;
    }
    return [];
  }
  function typeEksempel(e, maerker) {
    var html = 'Fx ', k = 0, markeret = false;
    for (var i = 0; i < e.v.length; i++) {
      var c = e.v[i], ciffer = /\d/.test(c), hit = ciffer && maerker.indexOf(k) !== -1;
      if (hit !== markeret) { html += hit ? '<u>' : '</u>'; markeret = hit; }
      html += esc(c);
      if (ciffer) k++;
    }
    return html + (markeret ? '</u>' : '');
  }
  function opdaterNummertyper() {
    var knapper = chipsEl.querySelectorAll('[data-m]'), q = felt.value, p = parse(q);
    if (p.f.tagQ || (p.moen && !p.cif)) q = '';
    for (var i = 0; i < knapper.length; i++) {
      var b = knapper[i], navn = b.getAttribute('data-m');
      if (!b.querySelector('.fn-soeg__chip-antal')) b.innerHTML = '<span class="fn-soeg__chip-label">' + esc(navn) + ' <span class="fn-soeg__chip-antal"></span></span><span class="fn-soeg__chip-eksempel" aria-hidden="true"></span>';
      var hits = indeks ? soeg(indeks, q, { moenster: navn }, true).hits : null;
      var kandidater = hits ? hits.map(function (h) { return h.e; }) : startNumre.filter(function (e) { return e.typer.indexOf(navn) !== -1; });
      var ledige = hits ? hits.filter(function (h) { return h.e.a; }).length : null;
      kandidater.sort(function (a, b) { return Number(b.a) - Number(a.a); });
      b.classList.toggle('fn-soeg__chip--tom', ledige === 0);
      if (ledige !== null) b.setAttribute('data-ledige', ledige);
      var eksempel = null, maerker = [];
      for (var j = 0; j < kandidater.length; j++) {
        maerker = typePositioner(kandidater[j].n, navn);
        if (maerker.length) { eksempel = kandidater[j]; break; }
      }
      if (!eksempel && TYPE_EKSEMPLER[navn]) {
        var fallback = TYPE_EKSEMPLER[navn];
        eksempel = { n: fallback[0], v: fallback[1] }; maerker = typePositioner(eksempel.n, navn);
      }
      b.querySelector('.fn-soeg__chip-antal').textContent = hits ? '(' + ledige + ')' : '(…)';
      var eksEl = b.querySelector('.fn-soeg__chip-eksempel');
      var eksHTML = eksempel ? typeEksempel(eksempel, maerker) : '&nbsp;';
      if (eksEl.innerHTML !== eksHTML) eksEl.innerHTML = eksHTML;
      b.setAttribute('aria-label', navn + (hits ? ', ' + ledige + ' ledige numre' : ', henter antal ledige numre') + (eksempel ? '. Eksempel ' + eksempel.v : ''));
    }
  }
  function tegnChips(res) {
    opdaterNummertyper();
    /* Pillerne kommer fra siden: ingen udskiftning af DOM, bredde eller rulning. */
    var valgt = ui.moenster ? normTekst(ui.moenster) : res && res.tagQ ? res.tagQ : '';
    var knapper = chipsEl.querySelectorAll('[data-m]');
    for (var i = 0; i < knapper.length; i++) {
      var aktiv = valgt && normTekst(knapper[i].getAttribute('data-m')) === valgt;
      knapper[i].setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      knapper[i].classList.toggle('fn-soeg__chip--aktiv', !!aktiv);
    }
  }

  function vaelgNummertype(navn) {
    ui.moenster = ui.moenster === navn ? null : navn;
    ui.type = null; ui.ledig = null; ui.max = null; ui.gemte = false;
    var p = parse(felt.value);
    if (p.f.tagQ || (p.moen && !p.cif)) felt.value = '';
    viste = MAKS_RAEKKER;
    tegn(); indhold.scrollTop = 0;
  }

  function saetResultat(html) {
    if (html === sidsteHTML) return;
    var top = indhold.scrollTop;
    resultatEl.innerHTML = html;
    sidsteHTML = html;
    indhold.scrollTop = top;
  }

  function startListe() {
    var hits = soeg(startNumre, '', { ledig: true }).hits;
    var html = '<ul class="fn-soeg__liste" role="list">';
    for (var i = 0; i < hits.length && i < MAKS_RAEKKER; i++) html += raekke(hits[i]);
    return html + '</ul>';
  }

  /* Kun skærmlæsere får besked. Resultatantal vises ikke. */
  function saetStatus(synlig, oplaest) {
    if (statusTimer) window.clearTimeout(statusTimer);
    statusTimer = window.setTimeout(function () { statusEl.textContent = oplaest || synlig || ''; }, 400);
  }

  /* Et nummer i tom tilstand: altid SVG-skabelonen, aldrig en tekstpille. */
  function nrKort(e) {
    return '<button type="button" class="fn-soeg__nrchip fn-soeg__nrchip--kort' + (e.a ? '' : ' fn-soeg__nrchip--solgt') + '" data-h="' + esc(e.h) + '" data-i="' + esc(e.v) + '" aria-label="' + esc(e.v) + ', ' + esc(prisOplaest(e)) + (e.a ? '' : ', solgt') + '">' +
      billedeHTML(e, esc(e.v), '') +
      '<span class="fn-soeg__nrchip-pris" aria-hidden="true">' + prisHTML(e) + '</span>' + '</button>';
  }
  function tomTilstand() {
    var html = '', i, g = laesJSON(OENSKE) || [], antal = 0;
    if (g.length && indeks) {
      var gc = '';
      for (i = 0; i < g.length && antal < 8; i++) { var ge = find(g[i].handle); if (ge) { antal++; gc += nrKort(ge); } }
      if (gc) html += '<section class="fn-soeg__sek"><h3 class="fn-soeg__h">Dine gemte numre</h3><div class="fn-soeg__nrchips">' + gc + '</div></section>';
    }
    var ss = sidstSet(), sc = '';
    if (indeks) for (i = 0; i < ss.length; i++) { var se = find(ss[i]); if (se) sc += nrKort(se); }
    if (sc) html += '<section class="fn-soeg__sek"><h3 class="fn-soeg__h">Sidst set</h3><div class="fn-soeg__nrchips">' + sc + '</div></section>';

    return html;
  }

  function alleFormerChips() {
    var f = {}, ud = '';
    for (var i = 0; i < indeks.length; i++) if (indeks[i].mnavn && normTekst(indeks[i].mnavn) !== 'gold') f[indeks[i].mnavn] = 1;
    var navne = Object.keys(f).sort();
    for (i = 0; i < navne.length; i++) ud += '<button type="button" class="fn-soeg__nrchip fn-soeg__nrchip--form" data-m="' + esc(navne[i]) + '">' + esc(navne[i]) + '</button>';
    return '<div class="fn-soeg__nrchips">' + ud + '</div>';
  }

  function planlaegTegn() {
    if (tegnPlanlagt) return;
    tegnPlanlagt = true;
    window.requestAnimationFrame(function () { tegnPlanlagt = false; tegn(); });
  }

  function tegn() {
    if (!aaben) return;
    resultatEl.setAttribute('aria-busy', indeks ? 'false' : 'true');
    var raa = felt.value;
    ryd.hidden = !raa;
    var harFiltre = ui.ledig !== null || ui.type || ui.max || ui.gemte || ui.moenster;
    var p = parse(raa);
    listeTitel.textContent = raa.trim() || harFiltre ? 'Resultater' : 'Ledige numre';
    var tom = !p.cif && !p.f.tagQ && !p.moen && !p.f.type && p.f.ledig == null && !p.f.max && !harFiltre;
    /* Rulhoejden bevares, naar listen blot vokser ("Vis flere") - ellers
       hoppede listen til toppen ved hvert tryk. */
    var behold = beholdRul; beholdRul = false;
    var rulY = behold ? indhold.scrollTop : 0;

    if (p.afvist) { felt.classList.remove('fn-soeg__input--ryst'); void felt.offsetWidth; felt.classList.add('fn-soeg__input--ryst'); }

    if (indeks) rod.setAttribute('data-indeks', ''); else rod.removeAttribute('data-indeks');
    if (!indeks) {
      tegnChips(null);
      var html = '';
      if (tom && startHTML && !indeksFejl) {
        /* Faerdige offentlige numre fra sidens HTML, synkront paa foerste tryk. */
        html = startHTML;
        rod.setAttribute('data-startnumre', '');
        saetStatus('', 'Ledige numre vises. Henter resten af kataloget.');
      } else {
        rod.removeAttribute('data-startnumre');
        saetStatus('', indeksFejl ? 'Kunne ikke hente numrene. Prøv igen.' : 'Henter numrene.');
        if (indeksFejl) {
          html = '<p class="fn-soeg__fejl">Kunne ikke hente numrene. Tjek forbindelsen, og prøv igen.</p><button type="button" class="fn-soeg__proev">Prøv igen</button><p class="fn-soeg__hint"><a href="/search?type=product&q=' + encodeURIComponent(raa) + '">Brug den almindelige søgning</a></p>';
        } else {
          var sk = '', antal = Math.max(12, Math.ceil(window.innerHeight / 66) + 2);
          for (var i = 0; i < antal; i++) sk += '<li class="fn-soeg__skelet" aria-hidden="true"></li>';
          html = '<span class="fn-sr">Henter numrene</span><ul class="fn-soeg__liste">' + sk + '</ul>' + (langsom ? '<p class="fn-soeg__fejl">Søgningen er lidt langsom lige nu. <a href="/search?type=product&q=' + encodeURIComponent(raa) + '">Brug den almindelige søgning</a>.</p>' : '');
        }
      }
      saetResultat(html);
      bundEl.hidden = false;
      efterTegn();
      return;
    }
    rod.removeAttribute('data-startnumre');

    felt.setAttribute('aria-invalid', p.afvist ? 'true' : 'false');
    if (!p.afvist) felt.classList.remove('fn-soeg__input--ryst');
    if (p.afvist) {
      saetStatus('Skriv højst 8 cifre', 'Et dansk telefonnummer har 8 cifre. Ret søgningen.');
      saetResultat('<p class="fn-soeg__hint">Et dansk telefonnummer har 8 cifre. Fjern de ekstra cifre, og prøv igen. Du kan også søge med +45 foran nummeret.</p>');
      bundEl.hidden = false;
      efterTegn();
      return;
    }

    if (tom) {
      /* Tomt felt: ledige numre foerst; gemte og sidst set ligger nedenunder.
         De faste nummertyper staar under feltet, saa
         kortet aldrig staar uden numre (Richard, 7. september 2026). */
      var alle = soeg(indeks, '', ui);
      seneste = alle;
      tegnChips(null);
      saetStatus('', 'Skriv cifre, eller vælg en nummertype.');
      var th = '', tn = Math.min(alle.hits.length, viste);
      if (tn) {
        th += '<ul class="fn-soeg__liste" role="list">';
        for (var ti = 0; ti < tn; ti++) th += raekke(alle.hits[ti]);
        th += '</ul>';
        if (alle.hits.length > tn) th += '<button type="button" class="fn-soeg__mere">Vis flere</button>';
      }
      th += tomTilstand();
      saetResultat(th);
      if (behold) indhold.scrollTop = rulY;
     
      sekundaer.textContent = 'Se alle numre';
      bundEl.hidden = false;
      efterTegn();
      return;
    }

    var res = soeg(indeks, raa, ui);
    seneste = res;
    tegnChips(res);

    var hits = res.hits, naer = res.naer, html = '', i;
    var qVist = res.cif ? formatQ(res.cif) : '';

    if (hits.length === 0 && naer.length === 0 && res.cif && res.cif.length <= 2) {
      saetStatus('Ingen præcise matches', 'Ingen numre matcher ' + qVist);
      html = '<p class="fn-soeg__hint">Prøv et andet ciffer, eller vælg et mønster.</p>';
      html += kontaktLinje();
      saetResultat(html); bundEl.hidden = false; efterTegn(); return;
    }

    if (hits.length === 0 && res.form) {
      saetStatus('Ingen matches', 'Ingen numre matcher mønstret ' + res.formVist);
      html = '<p class="fn-soeg__hint">Prøv et kortere mønster. Samme bogstav betyder samme ciffer, fx ab ab = 12 12. Eller vælg et mønster her:</p>' + alleFormerChips() + kontaktLinje();
      saetResultat(html); bundEl.hidden = false; efterTegn(); return;
    }
    if (hits.length === 0 && !res.cif && res.tagQ) {
      saetStatus('', '');
      html = '<p class="fn-soeg__hint">Der er ingen form, der hedder "' + esc(raa.trim()) + '". Vælg en her:</p>' + alleFormerChips();
      saetResultat(html); bundEl.hidden = false; efterTegn(); return;
    }

    if (hits.length === 0) {
      saetStatus('Ingen præcise matches', 'Ingen numre matcher ' + qVist);
      html = '';
      if (naer.length) {
        html += '<h3 class="fn-soeg__h">' + esc(res.overskriftNaer) + '</h3><ul class="fn-soeg__liste" role="list">';
        for (i = 0; i < naer.length; i++) html += raekke(naer[i], { naer: true });
        html += '</ul>';
      }
      html += kontaktLinje();
      saetResultat(html);
      sekundaer.textContent = 'Se alle numre';
      bundEl.hidden = false; efterTegn(); return;
    }

    saetStatus('', 'Søgningen er opdateret.');

    html = '<ul class="fn-soeg__liste" role="list">';
    var n = Math.min(hits.length, viste);
    for (i = 0; i < n; i++) html += raekke(hits[i]);
    html += '</ul>';
    if (hits.length > n) html += '<button type="button" class="fn-soeg__mere">Vis flere</button>';
    if (naer.length) {
      var nh = !res.ledigeFund ? 'Ledige numre med samme mønster' : 'Måske mente du';
      var samme = naer.filter(function (x) { return x.samme; }), andre = naer.filter(function (x) { return !x.samme; });
      if (samme.length) { html += '<h3 class="fn-soeg__h">' + nh + '</h3><ul class="fn-soeg__liste" role="list">'; for (i = 0; i < samme.length; i++) html += raekke(samme[i], { naer: true }); html += '</ul>'; }
      if (andre.length) { html += '<h3 class="fn-soeg__h">' + (samme.length || !res.ledigeFund ? esc(res.overskriftNaer) : nh) + '</h3><ul class="fn-soeg__liste" role="list">'; for (i = 0; i < andre.length; i++) html += raekke(andre[i], { naer: true }); html += '</ul>'; }
    }
    saetResultat(html);
    if (behold) indhold.scrollTop = rulY;
    sekundaer.textContent = 'Se alle numre';
    bundEl.hidden = false;
    efterTegn();
  }

  function kontaktLinje() {
    var q = felt && felt.value ? felt.value.trim() : '';
    return '<p class="fn-soeg__kontakt"><a class="fn-soeg__oensk" href="/pages/oensk-et-nummer' + (q ? '?q=' + encodeURIComponent(q) : '') + '">Ønsk et nummer</a> - så leder vi efter det, eller skaffer det. Eller skriv til <a href="mailto:info@firmanumre.dk">info@firmanumre.dk</a></p>';
  }

  function efterTegn() {
    var raekker = indhold.querySelectorAll('.fn-soeg__res');
    for (var i = 0; i < raekker.length; i++) raekker[i].setAttribute('tabindex', i === 0 ? '0' : '-1');
    if (fk() && fk().opsaetHjerter) fk().opsaetHjerter();
    if (sidstFokus) { var el = indhold.querySelector('.fn-soeg__res[data-h="' + sidstFokus + '"]'); if (el) el.focus(); sidstFokus = null; }
    opdaterHoejde();
  }

  /* ---------- aabne og lukke ---------- */

  /* Hele layout-viewportet daekkes ogsaa bag et gennemsigtigt tastatur.
     Kortet bruger visualViewport, saa felt og rulning er over tastaturet.
     Gem normalhoejden for browsere der ogsaa aendrer innerHeight. */
  var normalVvH = 0, normalVvB = 0, viewportPlanlagt = false;
  function opdaterHoejde() {
    if (!aaben) return;
    if (!telefon()) {
      rod.style.removeProperty('--fns-h');
      rod.style.removeProperty('--fns-top');
      rod.style.removeProperty('--fns-cover-h');
      rod.classList.remove('fn-kig--tastatur');
      rod.classList.remove('fn-kig--kompakt');
      normalVvH = normalVvB = 0;
      return;
    }
    var vv = window.visualViewport;
    /* Lad browseren styre pinch-zoom; det er ikke et tastaturskift. */
    if (vv && Math.abs(vv.scale - 1) > 0.05) return;
    var h = vv ? vv.height : window.innerHeight;
    var b = window.innerWidth;
    if (b !== normalVvB) { normalVvB = b; normalVvH = Math.max(window.innerHeight, document.documentElement.clientHeight); }
    normalVvH = Math.max(normalVvH, h);
    var tastatur = normalVvH - h > Math.max(120, normalVvH * 0.2);
    var top = vv ? vv.offsetTop : 0;
    rod.style.setProperty('--fns-h', h + 'px');
    rod.style.setProperty('--fns-top', top + 'px');
    rod.style.setProperty('--fns-cover-h', Math.max(normalVvH, window.innerHeight, document.documentElement.clientHeight, h + top) + 'px');
    rod.classList.toggle('fn-kig--tastatur', tastatur);
    rod.classList.toggle('fn-kig--kompakt', h < 480);
  }

  function planlaegViewport() {
    if (viewportPlanlagt || !aaben) return;
    viewportPlanlagt = true;
    window.requestAnimationFrame(function () { viewportPlanlagt = false; opdaterHoejde(); });
  }

  function aabn(fra, forQ) {
    if (aaben) { nulstilTraek(); if (!telefon()) felt.focus({ preventScroll: true }); return; }
    nulstilTraek();
    aaben = true; lukkeNr++; aabnetKl = Date.now(); langsom = false; viste = MAKS_RAEKKER;
    aabnedeFra = fra || document.activeElement;
    rod.hidden = false;
    if (!traekBundet) { traekBundet = true; bindSoegTraek(); }
    laasSiden();
    opdaterHoejde();
    /* Aabn synkront foer fokus. Desktop fokuserer feltet, mens mobil
       fokuserer dialogen og venter paa et bevidst tryk i feltet. Dermed
       virker Escape og fokusfaelden uden automatisk nummertastatur. */
    void rod.offsetHeight;
    rod.setAttribute('data-aaben', '');
    /* history.back() ved lukning faar browseren til at gendanne den TIDLIGERE
       historikposts rulhoejde - og den blev registreret som 0, fordi siden
       allerede var laast (body fixed) da pushState koerte. Maalt: siden landede
       paa 0 i stedet for 500 efter et traek-ned. Gendannelsen slaas fra, mens
       kortet er aabent, og rulhoejden saettes selv efter popstate. */
    try { if (!venterPaaHistorik) forrigeGendan = window.history.scrollRestoration; window.history.scrollRestoration = 'manual'; } catch (e) {}
    try { if (!venterPaaHistorik) window.history.pushState({ fns: 1 }, ''); } catch (e) {}
    if (forQ != null) felt.value = forQ;
    else { try { var q = window.sessionStorage.getItem(Q_NOEGLE); if (q) felt.value = q; } catch (e) {} }
    try {
      var fl = laesJSON(FILTRE_NOEGLE, window.sessionStorage);
      if (fl && typeof fl === 'object') ui = {
        ledig: null,
        type: null,
        max: null,
        gemte: false,
        moenster: typeof fl.moenster === 'string' && Array.prototype.some.call(chipsEl.querySelectorAll('[data-m]'), function (b) { return b.getAttribute('data-m') === fl.moenster; }) ? fl.moenster : null
      };
    } catch (e) {}
    /* Mobil: fokus og nummertastatur kraever et bevidst tryk i feltet. */
    if (telefon()) rod.focus({ preventScroll: true }); else felt.focus({ preventScroll: true });
    if (langsomTimer) window.clearTimeout(langsomTimer);
    langsomTimer = window.setTimeout(function () { if (!indeks) { langsom = true; tegn(); } }, 4000);
    hentIndeks().then(function () { if (aaben) tegn(); });
    tegn();
    opdaterHoejde();
  }

  function luk(fraHistorik) {
    if (!aaben) return;
    aaben = false;
    felt.blur();
    if (langsomTimer) window.clearTimeout(langsomTimer);
    rod.removeAttribute('data-aaben');
    nulstilTraek();
    rod.classList.remove('fn-kig--tastatur');
    try { window.sessionStorage.setItem(Q_NOEGLE, felt.value); skrivJSON(FILTRE_NOEGLE, ui, window.sessionStorage); } catch (e) {}
    gendanY = parseInt(document.documentElement.getAttribute('data-fn-laast-y') || '', 10);
    if (isNaN(gendanY)) gendanY = null;
    laasOp();
    var venterPaaBack = venterPaaHistorik;
    if (!fraHistorik && !venterPaaHistorik) {
      try {
        if (window.history.state && window.history.state.fns) { venterPaaBack = venterPaaHistorik = true; window.history.back(); }
      } catch (e) { venterPaaBack = venterPaaHistorik = false; }
    }
    if (!venterPaaBack) faerdigMedHistorik();
    var tilbage = aabnedeFra;
    var reduceret = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* En gammel lukkeanimation maa ikke skjule et kort, der er genåbnet. */
    var nr = ++lukkeNr;
    var faerdig = function () { if (aaben || nr !== lukkeNr) return; rod.hidden = true; ignorerFokusIndtil = Date.now() + 800; if (tilbage && tilbage.focus) tilbage.focus({ preventScroll: true }); };
    if (reduceret) faerdig(); else window.setTimeout(faerdig, 340);
  }

  var forrigeGendan = 'auto', gendanY = null, historikGendanNr = 0;
  function faerdigMedHistorik() {
    var y = gendanY, nr = ++historikGendanNr;
    gendanY = null;
    if (y != null) window.scrollTo(0, y);
    /* Safari gendanner historikkens rulhoejde efter popstate. Behold manual
       indtil naeste frame, saa browseren ikke overskriver vores placering. */
    window.requestAnimationFrame(function () {
      if (aaben || nr !== historikGendanNr) return;
      if (y != null) window.scrollTo(0, y);
      try { window.history.scrollRestoration = forrigeGendan || 'auto'; } catch (e) {}
    });
  }

  /* Forhaandsvisningen er slaaet fra igen (Richard, 11. september 2026):
     et klik/Enter paa en raekke gaar nu direkte til produktsiden i stedet
     for at aabne arket. `fk().aabnKig` kaldes bevidst ikke laengere - se
     opsaetKortKlik() i firmanumre-kort.js for samme aendring i gitteret. */
  function aabnKigFor(h, i) {
    try { window.sessionStorage.setItem(Q_NOEGLE, felt.value); skrivJSON(FILTRE_NOEGLE, ui, window.sessionStorage); } catch (e) {}
    noterSet(h);
    window.location.href = '/products/' + h;
  }

  /* ---------- haendelser ---------- */

  function opsaet() {
    rod = document.getElementById('FnSoeg');
    if (!rod) return;
    rod.setAttribute('tabindex', '-1');
    kort = rod.querySelector('.fn-kig__kort');
    indhold = rod.querySelector('.fn-kig__indhold');
    felt = rod.querySelector('.fn-soeg__input');
    ryd = rod.querySelector('.fn-soeg__ryd');
    chipsEl = rod.querySelector('.fn-soeg__chips');
    statusEl = rod.querySelector('.fn-soeg__status');
    bundEl = rod.querySelector('.fn-kig__bund');
    sekundaer = rod.querySelector('.fn-soeg__sekundaer');
    resultatEl = rod.querySelector('.fn-soeg__resultater');
    listeTitel = rod.querySelector('[data-resultat-titel]');
    try {
      var startEl = document.getElementById('FnSoegStart');
      var start = startEl ? JSON.parse(startEl.textContent) : null;
      if (start && gyldigtIndeks(start.numre)) {
        if (Array.isArray(start.systematiske)) start.systematiske.forEach(function (n) { if (/^\d{8}$/.test(n)) systematiskeNumre[n] = true; });
        startNumre = byg(start.numre);
        if (startNumre.some(function (e) { return e.a; })) startHTML = startListe();
      }
    } catch (e) { startNumre = []; }

    opdaterNummertyper();
    linjeEl = rod.querySelector('.fn-soeg__linje');

    felt.addEventListener('input', function () { viste = MAKS_RAEKKER; indhold.scrollTop = 0; planlaegTegn(); });
    ryd.addEventListener('click', function () { felt.value = ''; ui.moenster = null; viste = MAKS_RAEKKER; felt.focus({ preventScroll: true }); tegn(); });
    rod.querySelector('.fn-kig__luk').addEventListener('click', function () { luk(false); });
    rod.addEventListener('click', function (e) { if (e.target === rod) luk(false); });
    function visResultater() {
      if (!indeks && indeksFejl) {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(felt.value);
        return;
      }
      tegn();
      if (telefon()) felt.blur();
      indhold.scrollTop = 0;
    }
    rod.querySelector('.fn-soeg__felt').addEventListener('submit', function (e) { e.preventDefault(); visResultater(); });


    /* Et tryk paa en chip maa ikke tage fokus fra feltet: saa lukker
       tastaturet, arket skifter hoejde, og alt flytter sig. Det samme for
       bogmaerkerne i listen og ryd-knappen. */
    var holdFokus = function (e) { if (e.target.closest && e.target.closest('button')) e.preventDefault(); };
    bindTrykKnapper(chipsEl, 'button');
    bindTrykKnapper(ryd, '.fn-soeg__ryd');
    bindTrykKnapper(indhold, '.fn-soeg__gem, [data-m], .fn-soeg__mere, .fn-soeg__proev');
    chipsEl.addEventListener('pointerdown', holdFokus);
    ryd.addEventListener('pointerdown', holdFokus);
    chipsEl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-m]') : null;
      if (b) vaelgNummertype(b.getAttribute('data-m'));
    });

    indhold.addEventListener('click', function (e) {
      if (Date.now() < ignorerKlikIndtil) { e.preventDefault(); return; }
      var t = e.target;
      var proev = t.closest ? t.closest('.fn-soeg__proev') : null;
      if (proev) { langsom = false; hentIndeks(true); tegn(); return; }
      var moen = t.closest ? t.closest('[data-m]') : null;
      if (moen) { vaelgNummertype(moen.getAttribute('data-m')); return; }
      var mere = t.closest ? t.closest('.fn-soeg__mere') : null;
      if (mere) { viste += MAKS_RAEKKER; beholdRul = true; tegn(); return; }
      var gem = t.closest ? t.closest('.fn-soeg__gem') : null;
      if (gem) return;                                    /* firmanumre-kort.js haandterer bogmaerket */
      var nc = t.closest ? t.closest('.fn-soeg__nrchip') : null;
      if (nc && nc.getAttribute('data-h')) { aabnKigFor(nc.getAttribute('data-h'), nc.getAttribute('data-i')); return; }
      var li = t.closest ? t.closest('.fn-soeg__res') : null;
      if (!li) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      aabnKigFor(li.getAttribute('data-h'), li.getAttribute('data-i'));
    });

    /* Behold tastaturet under trykket. Blur ved touchstart flyttede den
       valgte raekke, inden browseren naaede at sende klikhaendelsen. */
    indhold.addEventListener('pointerdown', function (e) {
      trykRaekke = null;
      if (!e.target.closest) return;
      var kontrol = e.target.closest('.fn-soeg__gem, [data-m], .fn-soeg__mere, .fn-soeg__proev');
      var raekke = !kontrol && e.target.closest('.fn-soeg__res, .fn-soeg__nrchip[data-h]');
      if (raekke && (e.pointerType === 'touch' || e.pointerType === 'pen') && e.isPrimary) {
        trykRaekke = { id: e.pointerId, x: e.clientX, y: e.clientY, tid: Date.now(), h: raekke.getAttribute('data-h'), i: raekke.getAttribute('data-i') };
        e.preventDefault();
      } else if (kontrol) e.preventDefault();
    });
    indhold.addEventListener('pointermove', function (e) {
      if (trykRaekke && (Math.abs(e.clientX - trykRaekke.x) > 10 || Math.abs(e.clientY - trykRaekke.y) > 10)) trykRaekke = null;
    });
    indhold.addEventListener('pointercancel', function () { trykRaekke = null; });
    indhold.addEventListener('pointerup', function (e) {
      var tryk = trykRaekke; trykRaekke = null;
      if (!tryk || e.pointerId !== tryk.id || Date.now() - tryk.tid > 600 ||
          Math.abs(e.clientX - tryk.x) > 10 || Math.abs(e.clientY - tryk.y) > 10) return;
      /* Safari sender ikke click paa raekken efter preventDefault paa
         pointerdown. Et kort tryk vaelges derfor her; rulning annullerer. */
      ignorerKlikIndtil = Date.now() + 500;
      e.preventDefault();
      aabnKigFor(tryk.h, tryk.i);
    });



    rod.addEventListener('keydown', function (e) {
      var raekker = indhold.querySelectorAll('.fn-soeg__res'), i;
      var paaRaekke = e.target.classList && e.target.classList.contains('fn-soeg__res');
      if (e.key === 'Escape') {
        e.preventDefault();
        if (paaRaekke) felt.focus({ preventScroll: true }); else luk(false);
        return;
      }
      if (e.key === 'Enter' && e.target === felt) {
        e.preventDefault();
        if (e.isComposing) return;
        /* Soeg betyder vis resultater, ikke vaelg det foerste produkt.
           Tegn synkront, saa den seneste indtastning er med. Paa telefon
           skjules tastaturet, saa kunden kan se og vaelge blandt traeffene.
           Enter paa en eksplicit fokuseret raekke virker stadig nedenfor. */
        visResultater();
        return;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        if (paaRaekke) { e.preventDefault(); aabnKigFor(e.target.getAttribute('data-h'), e.target.getAttribute('data-i')); }
        return;
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
        if (!raekker.length) return;
        var idx = -1;
        for (i = 0; i < raekker.length; i++) if (raekker[i] === e.target) idx = i;
        if (e.target === felt && e.key === 'ArrowDown') idx = -1;
        else if (!paaRaekke) return;
        e.preventDefault();
        var ny = e.key === 'ArrowDown' ? idx + 1 : e.key === 'ArrowUp' ? idx - 1 : e.key === 'Home' ? 0 : raekker.length - 1;
        if (ny < 0) { felt.focus({ preventScroll: true }); return; }
        if (ny >= raekker.length) ny = raekker.length - 1;
        for (i = 0; i < raekker.length; i++) raekker[i].setAttribute('tabindex', i === ny ? '0' : '-1');
        raekker[ny].focus({ preventScroll: true });
        raekker[ny].scrollIntoView({ block: 'nearest' });
        return;
      }
      if (paaRaekke && (/^\d$/.test(e.key) || e.key === 'Backspace')) {
        felt.focus({ preventScroll: true });
        return;                                            /* tegnet lander i feltet */
      }
      if (e.key === 'Tab') {
        var fok = rod.querySelectorAll('input, button:not([hidden]), a[href], [tabindex="0"]');
        var liste = [];
        for (i = 0; i < fok.length; i++) if (fok[i].offsetParent !== null && !fok[i].hidden) liste.push(fok[i]);
        if (!liste.length) return;
        var foerste = liste[0], sidste = liste[liste.length - 1];
        if (e.shiftKey && document.activeElement === foerste) { e.preventDefault(); sidste.focus(); }
        else if (!e.shiftKey && document.activeElement === sidste) { e.preventDefault(); foerste.focus(); }
      }
    });

    window.addEventListener('popstate', function () {
      if (venterPaaHistorik) {
        venterPaaHistorik = false;
        /* back() fra den forrige lukning maa ikke lukke et genaabnet kort. */
        if (aaben) { gendanY = null; try { window.history.pushState({ fns: 1 }, ''); } catch (e) {} return; }
        faerdigMedHistorik();
        return;
      }
      if (aaben) { luk(true); return; }
      faerdigMedHistorik();                       /* back() fra luk() er landet: saet rulhoejden selv */
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !aaben) return;
      if (rod.contains(e.target)) return;                                 /* kortets egen lytter tager den */
      if (document.querySelector('.fn-kig:not(.fn-kig--soeg)[data-aaben]')) return;   /* preview oven paa: lukkes af sin egen lytter */
      luk(false);
    });
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', planlaegViewport); window.visualViewport.addEventListener('scroll', planlaegViewport); }
    window.addEventListener('resize', planlaegViewport);
    window.addEventListener('online', function () { if (aaben && indeksFejl) { hentIndeks(true); tegn(); } });
    window.addEventListener('fn:kig-lukket', function () { if (aaben && sidstFokus) { var el = indhold.querySelector('.fn-soeg__res[data-h="' + sidstFokus + '"]'); if (el) el.focus({ preventScroll: true }); sidstFokus = null; } });
    /* Opdater bogmaerker uden at nulstille listens rulhoejde. */
    window.addEventListener('fn:oenskeliste', function () {
      if (!aaben) return;
      var g = gemteHandles(), r = indhold.querySelectorAll('.fn-soeg__res'), i;
      for (i = 0; i < r.length; i++) r[i].classList.toggle('fn-soeg__res--gemt', !!g[r[i].getAttribute('data-h')]);
    });

    /* Aabningspunkter. Headerens soegeikon fanges i capture-fasen, saa
       Debutifys egen skuffe aldrig aabner; href="/search" bevares uden JS. */
    var ikoner = document.querySelectorAll('.js-drawer-open-button-top');
    for (var i = 0; i < ikoner.length; i++) {
      ikoner[i].addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); aabn(this); }, true);
      ikoner[i].addEventListener('pointerdown', forhent, { passive: true });
      ikoner[i].addEventListener('touchstart', forhent, { passive: true });
    }
    var felter = document.querySelectorAll('[data-fn-soeg-aaben]');
    for (i = 0; i < felter.length; i++) {
      felter[i].addEventListener('click', function (e) { e.preventDefault(); aabn(this); });
      felter[i].addEventListener('focus', function () { if (Date.now() < ignorerFokusIndtil) return; forhent(); aabn(this); });
      felter[i].addEventListener('pointerdown', forhent, { passive: true });
    }

    /* Cmd+F/Ctrl+F aabner IKKE kortet (Richard, 7. september 2026):
       browserens egen soegning skal virke som normalt. */

    /* Produktside: noter nummeret som set. */
    var prod = rod.getAttribute('data-fn-produkt');
    if (prod) noterSet(prod);

    /* ?q= i adressen aabner kortet med det samme. */
    var m = /[?&]q=([^&]*)/.exec(window.location.search);
    if (m && document.getElementById('FnSoeg')) {
      var q = decodeURIComponent(m[1].replace(/\+/g, ' '));
      /* Ikke paa /search og ikke paa "Ønsk et nummer", hvor ?q= udfylder
         formularen i stedet for at aabne kortet. */
      if (q && !/^\/search/.test(window.location.pathname) && window.location.pathname.indexOf('/pages/oensk-et-nummer') === -1) { forhent(); aabn(null, q); }
    }

    /* Forhent efter indlaesning, naar browseren har luft. */
    var idle = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 2500); };
    if (document.readyState === 'complete') idle(forhent); else window.addEventListener('load', function () { idle(forhent); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', opsaet);
  else opsaet();

  /* Til test i konsollen og i Patchright. */
  window.fnSoeg = { bygForm: bygForm, parse: parse, soeg: soeg, afstand: afstand, segmenter: segmenter, byg: byg, aabn: aabn, luk: luk, hent: hentIndeks,
                    indeks: function () { return indeks; }, typePositioner: typePositioner, nummertyper: nummertyper };
})();

// Publish only the custom search popup; Shopify measures /search separately.
(function () {
  'use strict';
  if (window.fnSearchMeasurement) return;
  window.fnSearchMeasurement = true;
  if (window.Shopify && Shopify.loadFeatures && !Shopify.customerPrivacy) {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function () {});
  }
  var timer, last = '';
  function publish() {
    var popup = document.getElementById('FnSoeg');
    var input = popup && popup.querySelector('.fn-soeg__input');
    if (!input || popup.hidden) return;
    var term = input.value.trim().replace(/\s+/g, ' ').slice(0, 80);
    if (!term) { last = ''; return; }
    if (term.length < 2 || /[@:/]/.test(term) || term === last) return;
    var privacy = window.Shopify && Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || typeof privacy.marketingAllowed !== 'function' || !privacy.analyticsProcessingAllowed() || !privacy.marketingAllowed()) return;
    if (!Shopify.analytics || !Shopify.analytics.publish) return;
    last = term;
    Shopify.analytics.publish('firmanumre:popup_search', {search_term: term});
  }
  function schedule(event) {
    if (!event.target.closest || !event.target.closest('#FnSoeg')) return;
    clearTimeout(timer);
    timer = setTimeout(publish, 750);
  }
  document.addEventListener('input', schedule);
  document.addEventListener('click', schedule);
})();
